import { ApprovalDialog } from "@/Workflow/Approval/ApprovalDialog";
import { EntityDialog, HtmlContentEditor, DataGrid, Validator } from "@serenity-is/corelib";
import { Config } from "@serenity-is/corelib";
import { SiteEntityDialog } from "./Base/SiteEntityDialog";
import { getLanguageList } from "./Helpers/LanguageList";
import "./SharedScriptTypes";
import "./Patches/ErrorHandling";
import "./Patches/ImageUploadEditorFix";
import "./Patches/RowSelectionFix";
import "./Patches/CellSelectionFix";
import "./Patches/FilteringSelectorFix"
import "./Patches/SlickItemLink";
import "./Patches/UIOverrides";
import "@/Administration/User/Authentication/Authorization";
import Dialogs from "./Dialogs";

Config.rootNamespaces.push('Matrix');
EntityDialog.defaultLanguageList = getLanguageList;
HtmlContentEditor.CKEditorBasePath = "~/Serenity.Assets/Scripts/ckeditor/";
DataGrid.defaultPersistanceStorage = window.localStorage;
SiteEntityDialog.ApprovalDialogClass = ApprovalDialog;

globalThis.Dialogs = Dialogs;

Validator.methods.url ??= function (value, element) {
    return Validator.optional(element) || /^(?:(?:(?:https?|ftp):)?\/\/)(?:(?:[^\]\[?\/<~#`!@$^&*()+=}|:";',>{ ]|%[0-9A-Fa-f]{2})+(?::(?:[^\]\[?\/<~#`!@$^&*()+=}|:";',>{ ]|%[0-9A-Fa-f]{2})*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z0-9\u00a1-\uffff][a-z0-9\u00a1-\uffff_-]{0,62})?[a-z0-9\u00a1-\uffff]\.)+(?:[a-z\u00a1-\uffff]{2,}\.?))(?::\d{2,5})?(?:[/?#]\S*)?$/i.test(value?.toString());
}